<header class="header">
  <div class="header-left">
    <img src="assets/img/logo.png" alt="Logo Órgano Judicial" class="logo">
    <h5>Panel de Administración - Utilidades del Sistema</h5>
  </div>
  @if(isAuthenticated)
  {
  <div class="header-right">
    <button class="btn btn-envio" (click)="logout()">
      <i class="fas fa-sign-out-alt"></i> Cerrar Sesión
    </button>
  </div>
}
</header>

@if(loading){
<div class="loading-overlay">
  <div class="loading-indicator">Procesando...</div>
</div>
}

<div class="container-fluid">
  <!-- Formulario de Login -->
   @if(!isAuthenticated){
  <div class="justify-content-center min-vh-100 bg-light p-3">
    <div class="login-container">
      <oaj-alert-itx></oaj-alert-itx>
      
      <div class="card shadow-sm login-card">
        <div class="card-body">
          <div class="text-center mb-4">
            <i class="fas fa-user-shield" style="font-size: 4rem; color: var(--primary-oscuro);"></i>
            <h3 class="titulo mt-3">Acceso de Administrador</h3>
            <p class="text-muted">Panel de Utilidades del Sistema</p>
          </div>

          <form (ngSubmit)="login()" #loginForm="ngForm">
            <div class="mb-3">
              <label for="usuario" class="form-label">Usuario</label>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fas fa-user"></i>
                </span>
                <input 
                  type="text" 
                  id="usuario"
                  class="form-control" 
                  placeholder="Ingrese su usuario"
                  [(ngModel)]="usuario"
                  name="usuario"
                  autocomplete="username"
                  (keyup.enter)="loginForm.ngSubmit.emit()"
                  required>
              </div>
            </div>

            <div class="mb-4">
              <label for="password" class="form-label">Contraseña</label>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="fas fa-lock"></i>
                </span>
                <input 
                  [type]="showPassword ? 'text' : 'password'" 
                  id="password"
                  class="form-control" 
                  placeholder="Ingrese su contraseña"
                  [(ngModel)]="password"
                  name="password"
                  autocomplete="current-password"
                  (keyup.enter)="loginForm.ngSubmit.emit()"
                  required>
                <button 
                  class="btn btn-outline-secondary" 
                  type="button"
                  (click)="togglePasswordVisibility()">
                  <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </div>

          </form>

          <div class="mb-3">
            @if (captchaValido === false) {
            <cjf-textual #captchaComponent (respuesta)="respuestaCaptcha($event)"></cjf-textual>
            }
            @else {
            <div class="alert alert-success mb-0" role="alert">
              <i class="fas fa-check-circle"></i> Captcha validado
            </div>
            }
          </div>

          <button 
            type="button" 
            class="btn btn-login w-100"
            [disabled]="loading || !usuario || !password || !captchaValido"
            (click)="login()">
            <i class="fas fa-sign-in-alt"></i> Iniciar Sesión
          </button>
        </div>
      </div>
    </div>
  </div>
}
  <!-- Menú Principal y Componentes -->
   @if(isAuthenticated){
  <div class="justify-content-center min-vh-100 bg-light p-3">
    <div class="admin-container">
      <oaj-alert-itx></oaj-alert-itx>

      <!-- Menú de Opciones -->
       @if(selectedOption === 'menu'){
      <div class="row">
        <div class="col-12 mb-4">
          <div class="welcome-card">
            <h2><i class="fas fa-tools"></i> Panel de Utilidades del Sistema</h2>
            <p>Seleccione la opción que desea administrar</p>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="menu-card" (click)="selectOption('registroMasivo')"
          (keypress)="selectOption('registroMasivo')" tabindex="0">
            <div class="menu-card-icon">
              <i class="fas fa-users-cog"></i>
            </div>
            <div class="menu-card-content">
              <h3>Registro Masivo</h3>
              <p>Carga masiva de usuarios mediante archivo Excel</p>
            </div>
            <div class="menu-card-arrow">
              <i class="fas fa-chevron-right"></i>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="menu-card" (click)="selectOption('envioCorreo')"
          (keypress)="selectOption('envioCorreo')" tabindex="1">
            <div class="menu-card-icon">
              <i class="fas fa-envelope-open-text"></i>
            </div>
            <div class="menu-card-content">
              <h3>Envío Correo Masivo</h3>
              <p>Envío masivo de correos a múltiples organismos</p>
            </div>
            <div class="menu-card-arrow">
              <i class="fas fa-chevron-right"></i>
            </div>
          </div>
        </div>
      </div>
   }
      <!-- Componente Registro Masivo -->
@if(selectedOption === 'registroMasivo'){
      <div>
        <div class="row mb-3">
          <div class="col-12">
            <button class="btn btn-envio" (click)="backToMenu()">
              <i class="fas fa-arrow-left"></i> Volver al Menú
            </button>
          </div>
        </div>
        <oaj-alta-usuarios-masivo-itx></oaj-alta-usuarios-masivo-itx>
      </div>
    }
      <!-- Componente Envío Correo Masivo -->
       @if(selectedOption === 'envioCorreo'){
      <div>
        <div class="row mb-3">
          <div class="col-12">
            <button class="btn btn-envio" (click)="backToMenu()">
              <i class="fas fa-arrow-left"></i> Volver al Menú
            </button>
          </div>
        </div>
        <oaj-envio-correo-masivo></oaj-envio-correo-masivo>
      </div>
    }
    </div>
  </div>
}
</div>
